import { Button, Card, Space } from "antd";
import { useLocation, useNavigate } from "react-router";

import { PageAlert as Alert } from "@/views/components/PageAlert";
import type { SpecialZoneReservationOrderUpdateParams } from "@zhihaoscm/entity";
import {
    loadZoneReservationOrderDetail,
    updateZoneReservationOrder,
    type DetailData
} from "./ZoneReservationOrderDetailPage";
import { ZoneReservationOrderEditDialog } from "./zoneContract/ZoneReservationOrderEditDialog";

export interface ZoneReservationOrderEditPageProps {
    loadDetail?: (id: string) => Promise<DetailData>;
    updateReservation?: (id: string, params: SpecialZoneReservationOrderUpdateParams) => Promise<unknown>;
}

/**
 * 专区预约单独立编辑页。
 *
 * Bug 要求编辑保持独立路由；业务字段和校验复用详情内完整编辑器，避免页面版再次漏掉物料、船舶和地址能力。
 */
export function ZoneReservationOrderEditPage({
    loadDetail = loadZoneReservationOrderDetail,
    updateReservation = updateZoneReservationOrder
}: ZoneReservationOrderEditPageProps) {
    const location = useLocation();
    const navigate = useNavigate();
    const reservationId = new URLSearchParams(location.search).get("id") || "";

    if (!reservationId) {
        return (
            <section aria-label="zone-reservation-order-edit-page" className="flex h-full min-h-full flex-col">
                <Card>
                    <h1 className="zone-reservation-order-edit-page__title">编辑预约单</h1>
                    <Alert message="缺少预约单编号" role="alert" type="error" />
                    <Space className="operation-fixed-btn" size={0}>
                        <Button aria-label="返回" onClick={() => navigate(-1)}>
                            返回
                        </Button>
                    </Space>
                </Card>
            </section>
        );
    }

    return (
        <ZoneReservationOrderEditDialog
            presentation="page"
            reservationId={reservationId}
            loadDetail={loadDetail}
            updateReservation={updateReservation}
            onCancel={() => navigate(-1)}
            onSaved={() => navigate(`/tradeManage/zoneReservationOrderDetail?id=${encodeURIComponent(reservationId)}`)}
        />
    );
}

export default ZoneReservationOrderEditPage;
